import React, { useEffect } from 'react';
import { bool, object } from 'prop-types';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Drawer from '@material-ui/core/Drawer';

import CallSourcesFilter from '../../Global/CallSourcesFilter';
import CallStatusesFilter from '../../Global/CallStatusesFilter';
import ClientsSelectFilter from '../../Global/ClientsSelectFilter';
import EquipmentSelectFilter from '../../Global/EquipmentSelectFilter';
import IssueTypesFilter from '../../Global/IssueTypesFilter';
import PrioritiesFilter from '../../Global/PrioritiesFilter';
import SitesSelectFilter from '../../Global/SitesSelectFilter';
import SystemsSelectFilter from '../../Global/SystemsSelectFilter';

import * as CoreActions from '../../../actions/coreActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './FiltersDrawer.module.css';

const FiltersDrawer = ({
    callSourcesFilter,
    callStatusesFilter,
    clientsFilter,
    companyInfo,
    equipmentFilter,
    fetchServiceItemList,
    isDrawerOpen,
    issueTypes,
    issueTypesFilter,
    prioritiesFilter,
    setAreFiltersApplied,
    setCallSourcesFilter,
    setCallStatusesFilter,
    setClientsFilter,
    setDrawerOpen,
    setEquipmentFilter,
    setIssueTypesFilter,
    setPrioritiesFilter,
    setProgressBarLoading,
    setSitesFilter,
    setSystemsFilter,
    sitesFilter,
    systemsFilter,
    ...props
}) => {

    useEffect(() => {
        setAreFiltersApplied(!areFiltersEmpty());
    } ,[
        callSourcesFilter,
        callStatusesFilter,
        clientsFilter,
        equipmentFilter,
        issueTypesFilter,
        prioritiesFilter,
        sitesFilter,
        systemsFilter
    ]);

    const reloadServiceItems = async () => {
        setProgressBarLoading(true);
        await fetchServiceItemList();
        setProgressBarLoading(false);
    };

    const areFiltersEmpty = () => {
        return isEmpty(callSourcesFilter.callSources) &&
               isEmpty(callStatusesFilter.callStatuses) &&
               isEmpty(clientsFilter.clients) &&
               isEmpty(clientsFilter.businessTypes) &&
               isEmpty(equipmentFilter.equipment) &&
               isEmpty(issueTypesFilter.issueTypes) &&
               isEmpty(prioritiesFilter.priorities) &&
               isEmpty(sitesFilter.sites) &&
               isEmpty(sitesFilter.buildingTypes) &&
               isEmpty(systemsFilter.systems);
    };

    const handleFilter = (callback, changeSet) => {
        callback(changeSet);

        reloadServiceItems();
    };

    return (
        <Drawer
            anchor="right"
            open={isDrawerOpen}
        >
            <ClickAwayListener
                onClickAway={(event) => {
                    if (event.target.id) {
                        return;
                    }

                    setDrawerOpen(false);
                }}
            >
                <div className={classes.FiltersDrawer}>
                    <div className={classes.drawerTitle}>
                        <p>Configure Service Call Filters</p>
                    </div>
                    <ClientsSelectFilter
                        companyId={companyInfo.companyId}
                        clientsFilter={clientsFilter}
                        onChangeClientsFilter={(changeSet) => handleFilter(setClientsFilter, changeSet)}
                    />
                    <SitesSelectFilter
                        companyId={companyInfo.companyId}
                        sitesFilter={sitesFilter}
                        onChangeSitesFilter={(changeSet) => handleFilter(setSitesFilter, changeSet)}
                    />
                    <EquipmentSelectFilter
                        equipmentFilter={equipmentFilter}
                        onChangeEquipmentFilter={(changeSet) => handleFilter(setEquipmentFilter, changeSet)}
                    />
                    <SystemsSelectFilter
                        systemsFilter={systemsFilter}
                        onChangeSystemsFilter={(changeSet) => handleFilter(setSystemsFilter, changeSet)}
                    />
                    <IssueTypesFilter
                        issueTypesFilter={issueTypesFilter}
                        onChangeIssueTypesFilter={(changeSet) => handleFilter(setIssueTypesFilter, changeSet)}
                    />
                    <PrioritiesFilter
                        prioritiesFilter={prioritiesFilter}
                        onChangePrioritiesFilter={(changeSet) => handleFilter(setPrioritiesFilter, changeSet)}
                    />
                    <CallStatusesFilter
                        callStatusesFilter={callStatusesFilter}
                        onChangeCallStatusesFilter={(changeSet) => handleFilter(setCallStatusesFilter, changeSet)}
                    />
                    <CallSourcesFilter
                        className={classes.CallSourcesFilter}
                        callSourcesFilter={callSourcesFilter}
                        onChangeCallSourcesFilter={(changeSet) => handleFilter(setCallSourcesFilter, changeSet)}
                    />
                </div>
            </ClickAwayListener>
        </Drawer>
    );
};

FiltersDrawer.defaultProps = {
    callSourcesFilter:  {},
    callStatusesFilter: {},
    clientsFilter:      {},
    equipmentFilter:    {},
    isDrawerOpen:       false,
    issueTypesFilter:   {},
    prioritiesFilter:   {},
    sitesFilter:        {},
    systemsFilter:      {}
};

FiltersDrawer.propTypes = {
    callSourcesFilter:  object,
    callStatusesFilter: object,
    clientsFilter:      object,
    equipmentFilter:    object,
    isDrawerOpen:       bool,
    issueTypesFilter:   object,
    prioritiesFilter:   object,
    sitesFilter:        object,
    systemsFilter:      object
};

const mapStateToProps = state => {
    return {
        callSourcesFilter:  state.svcManagement.callSourcesFilter,
        callStatusesFilter: state.svcManagement.callStatusesFilter,
        clientsFilter:      state.svcManagement.clientsFilter,
        companyInfo:        state.companyInfo,
        equipmentFilter:    state.svcManagement.equipmentFilter,
        isDrawerOpen:       state.svcManagement.isDrawerOpen,
        issueTypesFilter:   state.svcManagement.issueTypesFilter,
        prioritiesFilter:   state.svcManagement.prioritiesFilter,
        sitesFilter:        state.svcManagement.sitesFilter,
        systemsFilter:      state.svcManagement.systemsFilter
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersDrawer);
